var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"logo-title"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"ma-6 d-flex justify-center"},[(
            _vm.appName !== '' && _vm.appName !== 'ALCES Flow Development Staging'
          )?_c('v-img',{attrs:{"src":require(`@/assets/img/logo.png`),"max-width":"200"}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center"},[_c('h2',[_vm._v(_vm._s(_vm.appName))])])],1)],1),_c('amplify-auth',{attrs:{"title":"Sign in"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }